import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                banner: {
                    title1: "Have a",
                    title2: "Desire To",
                    title3: "Stop Drinking",
                    btn1: "Take a Self Test",
                    btn2: "Reach Us",
                },
                navbar: {
                    home: "Home",
                    about: "About AA",
                    reflections: "Daily Reflections",
                    meetings: "Meeting List",
                    selftest: "Self Test",
                    contact: "Where to find us",
                },
                about: {
                    title: "A.A. PREAMBLE©",
                    p1: "Alcoholics Anonymous is a fellowship of people who share their experience, strength and hope with each other that they may solve their common problem and help others to recover from  alcoholism. The only requirement for membership is a desire to stop drinking.There are no dues or fees for A.A. membership; we are self-supporting through our own contributions. ",
                    p2: "A.A. is not allied with any sect, denomination, politics, organization or institution; does not wish to engage in any controversy, neither endorses nor opposes any causes. Our primary purpose is to stay sober and help other alcoholics to achieve sobriety.",
                },
                aboutaa: {
                    title: "About",
                    title1: 'AA',
                    p1: "For over 90 years, Alcoholics Anonymous has helped millions of people recover from alcoholism and maintain sobriety.",
                    p2: "People affected by alcoholism have come together to form a worldwide fellowship. Today, in around 180 countries, AA is estimated to have over 123,000 groups and more than two million members.",
                    p3: "The only requirement for membership is a desire to stop drinking. There are no dues or fees for AA membership.",
                    p4: "Alcoholics Anonymous is not allied with any race, caste, religion, politics, institution, or organization. It does not wish to engage in any controversies, nor does it endorse or oppose any causes.",
                    p5: "The basic purpose of every group is to carry the message that “there is hope for those suffering from alcoholism.",
                    p6: "The Twelve Traditions of Alcoholics Anonymous emphasize the importance of anonymity, which serves as a spiritual foundation and a shield of protection for all members. AA members are responsible for preserving their own anonymity as well as that of others.Thus, since the foundation of AA is spiritual, it reminds us that principles must always come before personalities."
                },
                experience: {
                    title: "Our Experience",
                    desc: "For more than 80 years, A.A. has helped millions recover from alcoholism - to get sober and stay sober."
                },
                hope: {
                    title: "Hope",
                    desc: "You can't buy anything here, but you can take it. It works, always"
                },
                new: {
                    title: "New to AA?",
                    desc: "You can take what you need, feel it, create it, and use it. It works, always."
                },
                meeting: {
                    title: "Meeting Address",
                    desc: "Details about meetings, locations, and schedules for A.A. members."
                },
                support: {
                    title: "Self-Support",
                    desc: "Rejecting external aid. A global organization supported by its members."
                },
                service: {
                    title: "Service",
                    desc: "Helping others is a core principle; the program works by sharing experience, strength, and hope."
                },

                form: {
                    joinTitle: {
                        jo: "Jo",
                        in: "in",
                        wi: "Wi",
                        th: "th",
                        us: "Us"
                    },
                    title: "Form",
                    name: "Name",
                    email: "Email",
                    phone: "Phone Number",
                    message: "Message",
                    submit: "Submit",
                    note: "The details that you provide below is only for contact purposes & it will be maintained strictly anonymous."
                },
                trust: {
                    title1: "The Trust",
                    title2: "that made",
                    items: [
                        { number: "90", label: "Years in this Field", suffix: "yrs" },
                        { number: "180+", label: "Countries Reached" },
                        { number: "1M+", label: "People's Recovered", highlight: true }
                    ]
                },
                footer: {
                    home: "Home",
                    about: "About AA",
                    reflections: "Daily Reflections",
                    meetings: "Meeting List",
                    selftest: "Self Test",
                    contact: "Where to find us",
                    links: "Links"
                },
                footerpara: {
                    title: " Rejecting external aid. A global organization with their own self- support",
                    subtitle: " A.A. costs nothing and is supported through member contributions, so there are no dues or fees for A.A. membership."
                },
                footerparas: {
                    heading: "A Help",
                    heading1: "to those who",
                    heading3: "need it",
                    responsibilityTitle: "A.A.'s Responsibility Statement",
                    responsibilityText: "I am responsible, when anyone, anywhere reaches out for help, I want the hand of A.A. always to be there. And for that: I am responsible.",
                    helpline: "Helpline : +91 9884447648",
                    address: "4/189A,1st Street , MMDA Colony Main Road , \nMaduravoyal, Chennai - 600095 , Tamilnadu, INDIA"
                },
                selftest: {
                    title: "Are you an Alcoholic?",
                    note: "Answer these questions truthfully. Always consult a doctor for proper medical advice.",
                    questions: [
                        "1. Do you lose work time because of drinking?",
                        "2. Is drinking making your family life unhappy?",
                        "3. Do you drink because you are shy with other people?",
                        "4. Is drinking affecting your reputation?",
                        "5. Have you ever felt remorse after drinking?",
                        "6. Have you ever got into financial difficulties as a result of drinking?",
                        "7. Do you drink with low companions and in undesirable environments?",
                        "8. Has drinking made you careless of your family’s welfare?",
                        "9. Has your ambition decreased since drinking?",
                        "10. Do you crave a drink at a definite time daily?",
                        "11. Do you require a drink the next morning?",
                        "12. Does drinking cause you to have difficulty sleeping?",
                        "13. Has your efficiency decreased since drinking?",
                        "14. Is drinking jeopardizing your job or business?",
                        "15. Do you drink to escape from worries or trouble?",
                        "16. Do you drink alone?",
                        "17. Have you ever had a complete loss of memory as a result of drinking?",
                        "18. Have you ever been treated by a doctor because of drinking?",
                        "19. Do you drink to build up your self-confidence?",
                        "20. Have you ever been in a hospital or institution on account of drinking?"
                    ],
                    yes: "Yes",
                    no: "No",
                    prev: "Previous",
                    next: "Next",
                    submit: "Submit",
                    bottomNote: "If you answered 'Yes' to three or more questions, you are definitely an alcoholic. (These questions are adapted from Johns Hopkins University, Baltimore, USA)."
                },
                stepspage: {
                    title: "Unity",
                    list: [
                        "Our common welfare should come first; personal recovery depends upon A.A. unity.",
                        "For our group purpose there is but one ultimate authority — a loving God as He may express Himself in our group conscience. Our leaders are but trusted servants; they do not govern.",
                        "The only requirement for A.A. membership is a desire to stop drinking.",
                        "Each group should be autonomous except in matters affecting other groups or A.A. as a whole.",
                        "Each group has but one primary purpose — to carry its message to the alcoholic who still suffers.",
                        "An A.A. group ought never endorse, finance, or lend the A.A. name to any related facility or outside enterprise, lest problems of money, property, and prestige divert us from our primary purpose.",
                        "Every A.A. group ought to be fully self-supporting, declining outside contributions.",
                        "Alcoholics Anonymous should remain forever non-professional, but our service centers may employ special workers.",
                        "A.A., as such, ought never be organized; but we may create service boards or committees directly responsible to those they serve.",
                        "Alcoholics Anonymous has no opinion on outside issues; hence the A.A. name ought never be drawn into public controversy.",
                        "Our public relations policy is based on attraction rather than promotion; we need always maintain personal anonymity at the level of press, radio, and films.",
                        "Anonymity is the spiritual foundation of all our traditions, ever reminding us to place principles before personalities."
                    ]
                },
                stepspage1: {
                    title: "Recovery",
                    list: [
                        'We admitted we were powerless over alcohol — that our lives had become unmanageable.',
                        'Came to believe that a Power greater than ourselves could restore us to sanity.',
                        'Made a decision to turn our will and our lives over to the care of God as we understood Him.',
                        'Made a searching and fearless moral inventory of ourselves.',
                        'Admitted to God, to ourselves, and to another human being the exact nature of our wrongs.',
                        'Were entirely ready to have God remove all these defects of character.',
                        'Humbly asked Him to remove our shortcomings.',
                        'Made a list of all persons we had harmed, and became willing to make amends to them all.',
                        'Made direct amends to such people wherever possible, except when to do so would injure them or others.',
                        'Continued to take personal inventory and when we were wrong promptly admitted it.',
                        'Sought through prayer and meditation to improve our conscious contact with God as we understood Him, praying only for knowledge of His will for us and the power to carry that out.',
                        'Having had a spiritual awakening as the result of these Steps, we tried to carry this message to alcoholics, and to practice these principles in all our affairs.'
                    ]
                },
                stepspage2: {
                    title: "Service",
                    list: [
                        ' Final responsibility and ultimate authority for A.A. world services should always reside in the collective conscience of our whole Fellowship',
                        'The General Service Conference of A.A. has become, for nearly every practical purpose, the active voice and the effective conscience of our whole society in its world affairs.',
                        'To insure effective leadership, we should endow each element of A.A.—the Conference, the General Service Board and its service corporations, staffs, committees, and executives—with a traditional “Right of Decision.',
                        'At all responsible levels, we ought to maintain a traditional “Right of Participation,” allowing a voting representation in reasonable proportion to the responsibility that each must discharge.',
                        'Throughout our structure, a traditional “Right of Appeal” ought to prevail, so that minority opinion will be heard and personal grievances receive careful consideration.',
                        'The Conference recognizes that the chief initiative and active responsibility in most world service matters should be exercised by the trustee members of the Conference acting as the General Service Board.',
                        'The Charter and Bylaws of the General Service Board are legal instruments, empowering the trustees to manage and conduct world service affairs. The Conference Charter is not a legal document; it relies upon tradition and the A.A. purse for final effectiveness.',
                        'The trustees are the principal planners and administrators of over-all policy and finance. They have custodial oversight of the separately incorporated and constantly active services, exercising this through their ability to elect all the directors of these entities. ',
                        'Good service leadership at all levels is indispensable for our future functioning and safety. Primary world service leadership, once exercised by the founders, must necessarily be assumed by the trustees. ',
                        'Every service responsibility should be matched by an equal service authority, with the scope of such authority well defined. ',
                        'The trustees should always have the best possible committees, corporate service directors, executives, staffs, and consultants. Composition, qualifications, induction procedures, and rights and duties will always be matters of serious concern',
                        'The Conference shall observe the spirit of A.A. tradition, taking care that it never becomes the seat of perilous wealth or power; that sufficient operating funds and reserve be its prudent financial principle; that it place none of its members in a position of unqualified authority over others; that it reach all important decisions by discussion, vote, and whenever possible, substantial unanimity; that its actions never be personally punitive nor an incitement to public controversy; that it never perform acts of government; that, like the Society it serves, it will always remain democratic in thought and action.'
                    ]
                },
                principles: {
                    // title: "Unity • Recovery • Service",
                    items: [

                        {
                            title: "Unity",
                            desc: "We come together with strength in unity, sharing hope and fellowship to heal as one.",
                            href: '/unity'
                        },

                        {
                            title: "Service",
                            desc: "Carrying the message to others, we serve with love, compassion and commitment.",
                            href: '/service'
                        },
                        {
                            title: "Recovery",
                            desc: "A journey of change and growth, helping us live free from the struggles of addiction.",
                            href: '/recovery'
                        }

                    ],
                },
            },
        },
        ta: {
            translation: {
                banner: {
                    title1: "குடிப்பதை நிறுத்த",
                    title2: "விருப்பமா அல்லது",
                    title3: "குடிப்பழக்கம் பிரச்சனையாக உள்ளதா",
                    btn1: "சுய பரிசோதனை செய்யவும்",
                    btn2: "எங்களை அணுகவும்",
                },
                navbar: {
                    home: "முகப்பு",
                    about: "AA பற்றி",
                    reflections: "தினசரி சிந்தனைகள்",
                    meetings: "சந்திப்பு பட்டியல்",
                    selftest: "சுய பரிசோதனை",
                    contact: "எங்களை எங்கு காணலாம்",
                },
                about: {
                    title: "AA முகவுரை",
                    p1: "ஆல்கஹாலிக்ஸ் அனானிமஸ்' என்பது தங்களுடைய அனுபவம், தெம்பு, நம்பிக்கை இவைகளை ஒருவருக்கொருவர் பகிர்ந்துகொள்வதின் மூலம் தங்கள் பொதுப் பிரச்சினைக்கு தீர்வு காணவும் மற்றவர்களுக்கு குடிநோயிலிருந்து மீளவும், உதவும் மக்கள் சார்ந்த இயக்கம். குடியை நிறுத்தவேண்டும் என்ற விருப்பமே இதில் அங்கத்தினராக ஒரே தகுதி இதற்கு சந்தா இல்லை. நாங்கள் விரும்பி கொடுக்கும் பொருள் உதவியைக் கொண்டு இதை நடத்துகின்றோம்.",
                    p2: "AA எந்த ஒரு இனம், ஜாதி, மதம், அரசியல், நிறுவனம் அமைப்பு போன்றவைகளுடன் இணைவதில்லை எந்தவித கருத்து வேறுபாடுகளிலும் ஈடுபட விரும்புவதில்லை. எங்களுக்கு சம்பந்தமற்ற விவகாரங்களை எதிர்ப்பதோ, ஆதரிப்பதோ இல்லை. நாங்கள் தெளிவுடன் இருப்பதும் மற்றக் குடிநோயாளிகள் தெளித்தன்மை அடைய உதவுவதும் தான் அடிப்படை நோக்கம்.",
                },
                aboutaa: {
                    title: 'AA',
                    title1: 'பற்றி',

                    p1: "90 ஆண்டுகளின் நிறைவாக மில்லியன் கணக்கான மக்கள் குடிப்பழக்கத்திலிருந்து மீண்டு வரவும், மது அருந்தாமல் இருக்கவும் ஆல்கஹாலிக்ஸ் அனானிமஸ் அமைப்பு உதவியுள்ளது.",
                    p2: "குடி நோயால் பாதிக்கப்பட்டவர்கள் ஒன்றிணைந்து, தோராயமாக180 நாடுகளில் உலகம் தழுவிய அமைப்பாக 123,000. குழுக்களால் இரண்டு மில்லியனுக்கும் அதிகமான உறுப்பினர்கள் இருப்பதாக மதிப்பிடப்பட்டுள்ளது",
                    p3: "குடியை நிறுத்த வேண்டும் என்ற விருப்பமே இதில் உறுப்பினராவதற்கு தேவையான ஒரே தகுதி. இதற்கு சந்தா இல்லை.",
                    p4: "ஆல்கஹாலிக்ஸ் அனானிமஸ் எந்த ஒரு இனம், ஜாதி, மதம், அரசியல், நிறுவனம், அமைப்பு போன்றவைகளுடன் இணைவதில்லை. எந்தவித கருத்து வேறுபாடுகளிலும் ஈடுபட விரும்புவதில்லை. எங்களுக்கு சம்பந்தமற்ற விவகாரங்களை எதிர்ப்பதோ, ஆதரிப்பதோ இல்லை.",
                    p5: "குடி நோயின் தாக்கத்தால் அவதிப்பட்டுக் கொண்டிருப்பவர்களுக்கு விடிவு உண்டு என்ற செய்தியை எடுத்துச் சொல்வதே ஒவ்வொரு குழுவின் அடிப்படை நோக்கமாகும்",
                    p6: "ஆல்கஹாலிக்ஸ் அனானிமஸ் 12, கோட்பாடுகளின் முக்கியத்துவம் குழுவிலுள்ள அதன் உறுப்பினர்களுக்கு அநாமதேயத்தை வலியுறுத்தி பாதுகாப்பு அரணாக விளங்குகிறது. ஆல்கஹாலிக்ஸ் அனானிமஸ் உறுப்பினர்கள் தங்கள் சொந்த அநாமதேயத்திற்கும், மற்றவர்களின் அநாமதேயத்திற்கும் பொறுப்பாவார்கள். ஆகவே நமது கோட்பாடுகளின் அஸ்திவாரம் ஆன்மீகமே , என்பதால் தனி நபரை விட தத்துவங்களுக்கே முதன்மை தர வேண்டும் என்பதை நமக்கு நினைவூட்டுகிறது."
                },
                experience: {
                    title: "எங்கள் அனுபவம்",
                    desc: "80 ஆண்டுகளுக்கும் மேலாக, A.A. மது பழக்கத்திலிருந்து கோடிக்கணக்கானவர்களை மீண்டு, பூரணமாக இருக்க உதவியுள்ளது."
                },
                hope: {
                    title: "நம்பிக்கை",
                    desc: "இங்கே எதையும் வாங்க முடியாது, ஆனால் எடுத்துக்கொள்ளலாம். இது எப்போதும் செயல்படும்."
                },
                new: {
                    title: "AA-க்கு புதியவரா?",
                    desc: "உங்களுக்கு தேவையானதை எடுத்துக்கொள்ளலாம், உணரலாம், உருவாக்கலாம், பயன்படுத்தலாம். இது எப்போதும் செயல்படும்."
                },
                meeting: {
                    title: "சந்திப்பு முகவரி",
                    desc: "A.A. உறுப்பினர்களுக்கான கூட்டங்கள், இடங்கள் மற்றும் அட்டவணை விவரங்கள்."
                },
                support: {
                    title: "சுய ஆதரவு",
                    desc: "வெளி உதவியை நிராகரித்து, உறுப்பினர்களால் ஆதரிக்கப்படும் ஒரு உலகளாவிய அமைப்பு."
                },
                service: {
                    title: "சேவை",
                    desc: "மற்றவர்களுக்கு உதவுவது ஒரு முக்கியக் கொள்கை; அனுபவம், வலிமை மற்றும் நம்பிக்கையை பகிர்ந்து கொண்டு இந்த திட்டம் செயல்படுகிறது."
                },
                form: {
                    joinTitle: {   // Tamil version
                        jo: "எ",
                        in: "ங",
                        wi: "ள",
                        th: "ு",
                        us: "டுடன்"
                    },
                    title: "படிவம்",
                    name: "பெயர்",
                    email: "மின்னஞ்சல்",
                    phone: "கைபேசி எண்",
                    message: "செய்தி",
                    submit: "சமர்ப்பிக்க",
                    note: "நீங்கள் கீழே வழங்கும் விவரங்கள் தொடர்பு கொள்ளும் நோக்கத்திற்காக மட்டுமே பயன்படுத்தப்படும், மேலும் அவை கடுமையாக ரகசியமாக வைக்கப்படும்."
                },
                trust: {
                    title1: "நம்பிக்கை",
                    title2: "உருவாக்கியது",
                    items: [
                        { number: "90", label: "ஆண்டுகள் அனுபவம்", suffix: "ஆ" },
                        { number: "150+", label: "நாடுகள் சென்றடைந்தது" },
                        { number: "1M+", label: "மீண்டு வந்த மக்கள்", highlight: true }
                    ]
                },
                selftest: {
                    title: "நீங்கள் ஒரு குடிநோயாளியா?",
                    note: "இந்தக் கேள்விக்கு விடை சொல்வதற்கு கீழ்க்கண்ட கேள்விகளை உங்களை நீங்களே கேட்டுக் கொள்ளுங்கள். எவ்வளவு நேர்மையாக முடியுமோ அவ்வளவு நேர்மையாக பதில் சொல்லுங்கள். (எல்லாக் கேள்விகளுக்கும் இல்லை என்பது உங்கள் விடையானால். உங்கள் வாழ்க்கைத் துணைவியார் அல்லது குடும்பத்தில் உங்களுக்கு மிக நெருக்கமானவர் உதவியுடன் மறுபடியும் அவற்றிற்கு பதில் சொல்லுங்கள்)",
                    questions: [
                        "1. குடிப்பழக்கத்தினால் வேலை செய்யும் நேரத்தை இழக்கிறீர்களா?",
                        "2. குடிப்பது உங்கள் குடும்ப வாழ்க்கையை மகிழ்ச்சியற்றதாகச் செய்கிறதா?",
                        "3. நீங்கள் மற்றவர்களுடன் பழகக் கூச்சப்படுவதால் குடிக்கிறீர்களா?",
                        "4. குடிப்பது உங்கள் நற்பெயரை பாதிக்கிறதா?",
                        "5. குடித்த பிறகு உங்களுக்கு எப்போதாவது குற்றம் செய்துவிட்டோம் என்ற வருத்த உணர்ச்சி ஏற்பட்டிருக்கிறதா?",
                        "6. குடியின் விளைவாக நீங்கள் எப்போதாவது பணக்கஷ்டத்திற்கு ஆளாகியிருக்கிறீர்களா?",
                        "7. குடிக்கும்போது நீங்கள் தரக்குறைவான தோழர்களையும் சூழ்நிலைகளையும் நாடி இருக்கிறீர்களா?",
                        "8. குடி உங்கள் குடும்ப நலனைப்பற்றிக் கவலைப்படாதவராகச் செய்திருக்கிறதா?",
                        "9. நீங்கள் குடிக்க ஆரம்பித்ததிலிருந்து வாழ்க்கையில் குடிக்க வேண்டும் என்ற தீவிர விருப்பம் உங்களுக்கு ஏற்படுகிறதா?",
                        "10. தினந்தோறும் ஒரு குறிப்பிட்ட நேரத்தில் குடிக்க வேண்டும் என்ற தீவிர விருப்பம் உங்களுக்கு ஏற்படுகிறதா?",
                        "11. மறுநாள் காலையில் உங்களுக்குக் குடி தேவைப்படுகிறதா?",
                        "12. குடிப்பது உங்கள் தூக்கத்தைப் பாதிக்கிறதா?",
                        "13. குடிக்க தொடங்கியதிலிருந்து உங்கள் வேலைத்திறன் குறைந்துவிட்டதா?",
                        "14. குடிப்பது உங்களுடைய தொழில் அல்லது வியாபாரத்தை ஆபத்திற்குள்ளாக்கிக் கொண்டுடிருக்கிறதா?",
                        "15. கவலைகள் அல்லது தொல்லைகளில் இருந்து தப்பித்துக் கொள்ள நீங்கள் குடிக்கிறீர்களா?",
                        "16. நீங்கள் தனிமையில் குடிக்கிறீர்களா?",
                        "17. நீங்கள் குடித்ததின் பலனாக எப்போதாவது முழு ஞாபக மறதி ஏற்பட்டுள்ளதா?",
                        "18. குடித்ததின் விளைவாக எப்போதாவது ஒரு டாக்டர் உங்களுக்கு சிகிச்சை செய்திருக்கிறாரா?",
                        "19. உங்களது தன்னம்பிக்கையை அதிகரித்துக் கொள்வதற்காக நீங்கள் குடிக்கிறீர்களா?",
                        "20. குடித்ததினால் மருத்துவமனையிலோ, சிகிச்சை நிறுவனத்திலோ இருந்திருக்கிறீர்களா?"
                    ],
                    yes: "ஆமாம்",
                    no: "இல்லை",
                    prev: "முந்தைய",
                    next: "அடுத்த",
                    submit: "சமர்ப்பிக்கவும்",
                    bottomNote: "ஏதேனும் ஒரு கேள்விக்கு ஆம் என்று விடை சொல்லியிருந்தால் நீங்கள் ஒரு குடிநோயாளியாக இருக்கலாம் என்பதற்கு எச்சரிக்கையாகும். ஏதேனும் இரண்டிற்கு ஆம் என்று விடை சொல்லியிருந்தால் நீங்கள் குடிநோயாளியாக இருக்க வாய்ப்புகள் உண்டு. மூன்று தடவை அல்லது அதற்கு மேல் ஆம் என்று விடை சொல்லியிருந்தால் நீங்கள் உறுதியாக ஒரு குடிநோயாளிதான். (மேற்கண்ட சோதனைக் கேள்விகள் ஒருவர் குடிநோயாளியா இல்லையா என்று தீர்மானிக்க அமெரிக்கா, பால்டிமோ நகர், ஜான் ஹாப்கின்ஸ் பல்கலைக்கழகத்தினரால் பயன்படுத்தப்படுகின்றன.)"
                },
                footer: {
                    home: "முகப்பு",
                    about: "AA பற்றி",
                    reflections: "தினமும் நம் சிந்தனைக்கு",
                    meetings: "சந்திப்பு பட்டியல்",
                    selftest: "சுய பரிசோதனை",
                    contact: "எங்களை எங்கு காணலாம்",
                    links: "இணைப்புகள்"
                },

                footerpara: {
                    title: " வெளி உதவியை மறுத்து தன் சொந்த பலத்தாலேயே இயங்குகிறது.",
                    subtitle: "A.A.வில் இணைவதற்கு எந்தவித சந்தாவோ கட்டணங்களோ இல்லை, அனுபவம், தெம்பு, மற்றும் நம்பிக்கை பெற்ற உறுப்பினர் பங்களிப்புகள் மூலம் நடத்தப்படுகிறது."
                },
                footerparas: {
                    heading: "",
                    heading1: "தேவைப்படுபவர்களுக்கு ",
                    heading3: "ஒரு உதவி",
                    responsibilityTitle: "நான் பொறுப்பாளி....",
                    responsibilityText: "எப்போதாவது, யாராவது, எங்காவது உதவி வேண்டினால், அங்கு எப்போதும் A.A.வின் உதவிக்கரம் இருக்க வேண்டும். என்பது என் அவா! அதற்கு: நான் பொறுப்பாளி.",
                    helpline: "உதவி எண் : +91 9884447648",
                    address: "தென்னிந்திய பொது சேவை அலுவலகம், எண்.4/189A, 1வது தெரு, எம்எம்டிஏ காலனி பிரதான சாலை, மதுரவாயல், சென்னை- 600095, தமிழ்நாடு, இந்தியா."
                },
                principles: {
                    // title: "ஒற்றுமை • சேவை • நலமடைதல்",
                    items: [
                        {
                            title: "ஒற்றுமை",
                            desc: "ஒற்றுமையின் வலிமையுடன் நாம் ஒன்றிணைந்து, நம்பிக்கையும் நட்பும் பகிர்ந்து ஒரே குடும்பமாக குணமடைகிறோம்.",
                            href: '/unity'
                        },

                        {
                            title: "சேவை",
                            desc: "செய்தியை பிறருக்கு எடுத்துச் சென்று, அன்பும் அர்ப்பணிப்புடன் நாம் சேவை செய்கிறோம்.",
                            href: '/recovery'

                        },
                        {
                            title: "நலமடைதல்",
                            desc: "மாற்றமும் வளர்ச்சியும் நிறைந்த ஒரு பயணம்; அடிமைத்தனத்தின் சிக்கல்களில் இருந்து விடுபட உதவுகிறது.",
                            href: '/service'

                        },
                    ],
                },
                stepspage: {
                    title: "ஒற்றுமை",
                    list: [
                        "நமது பொதுநலன் தான் நமக்கு முக்கியமானது. நாம்    குணமடைவது நமது ஒற்றுமையை பொறுத்திருக்கிறது.",
                        "நமது குழுவின் நடவடிக்கைகளுக்கு அன்பான இறைவனே அதிகாரி --- அவர் நமது குழுவின் மனசாட்சியின் மூலம் தீர்மானத்தை வெளிப்படுத்துவார் என கருதுகிறோம். நமது தலைவர்கள் உண்மையில் நமது நம்பிக்கை பெற்ற சேவையாளர்கள்; அவர்கள் ஆதிக்கம் செலுத்துவதில்லை.",
                        "குடிப்பதை நிறுத்த வேண்டும் என்ற விருப்பமே A.A வில் உறுப்பினராவதற்கு தேவையான ஒரே தகுதி.",
                        "A.A வை மொத்தமாகவோ, மற்ற குழுக்களையோ பாதிக்காத விவகாரங்களில் ஒவ்வொரு குழுவும்  சுயேட்சையாகச் செயல்படும்.",
                        "குடிநோயால் அவதிப்பட்டுக் கொண்டிருப்பவர்களுக்கு விடிவு உண்டு என்ற செய்தியை எடுத்துச் சொல்வது ஒவ்வொரு குழுவின் அடிப்படை நோக்கம்.",
                        "A A குழுக்கள் தங்கள் ஆதரவு, பணம், பெயர் இவைகளை அதைப்போன்ற சம்பந்தப்பட்ட அமைப்பிற்கோ அல்லது வெளி நிறுவனங்களுக்கோ கொடுத்து உதவக்கூடாது. ஏனெனில் பணம் சொத்து புகழ் போன்றவை நம்மை நம்முடைய அடிப்படை நோக்கத்திலிருந்து திசைதிருப்பி விடலாம். ",
                        "ஒவ்வொரு குழுவும் வெளி உதவியை மறுத்துத் தன் சொந்த பலத்தாலேயே இயங்க வேண்டும்.",
                        " A. A என்றென்றும்  தொழில் அடிப்படையில்  செயல்படக்கூடாது.  ஆனால் நமது சேவை மையங்கள் சில வேலைகளுக்காக சிறப்பு பணியாளர்களை நியமிக்கலாம். ",
                        "A. A வை கட்டுப்பாடு செய்யும் அமைப்பாக ஒருபோதும் நிறுவப்படக்கூடாது. ஆனால் தொண்டு செய்பவர்களுக்கு மட்டுமே பொறுப்பான சேவை மையம், சேவை குழு போன்றவைகளை உருவாக்கலாம். ",
                        "வெளி விவகாரங்களைப் பற்றி A. A க்கு  அபிப்பிராயங்கள் கிடையாது. ஆகையால் பொதுக் கருத்து வேறுபாடுகளில் A A வின் பெயரை ஈடுபடுத்தக் கூடாது.",
                        "நமது பொதுத் தொடர்பு கொள்கை எடுத்துக்காட்டு மூலம் இருக்க வேண்டுமே தவிர விளம்பரங்களால் அல்ல. பத்திரிகை, ரேடியோ, டிவி,  சினிமா  போன்றவைகளில் நம்மை தனிப்பட்ட முறையில் இன்னார் என்று வெளிப்படுத்தலாகாது.",
                        "நாம் இன்னாரென்று வெளிப்படுத்தாமல் இருப்பதே நமது கோட்பாடுகளின் ஆன்மீக அஸ்திவாரம். இது தனிமனித ஆளுமையை விட நமது தத்துவங்கள் தான் முக்கியமென வலியுறுத்துகிறது."
                    ]
                },
                stepspage1: {
                    title: "சேவை",
                    list: [
                        "AA உலக சேவையின் இறுதி பொறுப்பும், முடிவான அதிகாரமும் AA தோழமை குழுக்களின் ஒட்டுமொத்த மன ஒற்றுமையில் தான் இருக்கிறது",
                        "AAவின் பொது சேவை மாநாடு என்பது நமது தோழமை அமைப்பின் உலக விவகாரங்கள் குறித்து பிரதிநிதியின் குரலாகவும் அதன் மனசாட்சிகளாகவும் உள்ளது.",
                        "ஒரு செயலாற்று மிக்க தலைமைத்துவம் உருவாக்க வேண்டும் எனில், நாம் AAயின் எல்லா அங்கங்களுக்கும் மாநாடு, பொது சேவை வாரியம், சேவை கழகங்கள், ஊழியர்கள், குழுக்கள், செயல் குழுவினர், முடிவெடுக்கும் உரிமையை அளிக்க வேண்டும்.",
                        "பொறுப்பான எல்லா மட்டங்களிலும் நாம் பங்கேற்கும் உரிமை என்ற பாரம்பரியத்தை கடைபிடிக்க வேண்டும். ஒவ்வொருவரும் நிறைவேற்ற வேண்டிய கடமைகளுக்கும்,  பொறுப்புகளுக்கும் ஏற்ற வகையில் விகிதாச்சார முறைப்படி ஓட்டெடுப்பு பிரதிநிதித்துவம் அளிக்கலாம்.",
                        "நமது அமைப்பில் குறியீட்டு உரிமை பாதுகாக்கப்பட வேண்டும்.  அப்போதுதான் சிறுபான்மையினரின் கருத்துக்கள் கேட்கப்படும். மற்றும் தனிநபர்கள் மணக்குறைகள் பரிசீலிக்கப்படும்.",
                        "நமது மாநாடு ஒன்றை தெளிவாக அங்கீகரித்துள்ளது. உலக சேவை சம்பந்தப்பட்ட விஷயங்களில் பூர்வமாக வேலைகள் தொடங்குவது. மற்றும் செயலாற்ற பொறுப்புகள் ஆகியவை மாநாட்டின் டிரஸ்டி  உறுப்பினர்களிடம்தான் உள்ளது. இவர்கள் பொது சேவை வாரியத்தின் சார்பில் செயல்படுவர்.",
                        "பொது சேவை வாரியத்தின் சாசனமும், சட்ட திட்டங்களும் தான் சட்டப் பத்திரங்கள், அது டிரஸ்டிகளுக்கு உலக சேவை சம்பந்தப்பட்ட விஷயங்களை நிர்வகிக்கும் அதிகாரத்தை அளிக்கிறது.  மாநாடு சாசனம் சட்டபத்திரம் அல்ல அது கோட்பாடுகளையும் AA நிதியையும் சார்ந்து நிற்பது.",
                        "டிரஸ்டிகள் தான் கொள்கை வரைவு, நிதி ஆகியவற்றை திட்டமிடுபவர்களும்,  நிர்வாகிப்பவர்களும். தனிப்பட்ட முறையில் இயங்கி வரும் சேவை மையங்கள் இவர்கள் அதற்கென இயக்குனர்களை தேர்ந்தெடுப்பதன் மூலம் அதனை கண்காணிக்கலாம்.",
                        "நமது எதிர்கால செயல்பாட்டிற்கும், பாதுகாப்பிற்கும், திறமையான சேவை மனப்பான்மையிலான தலைமைத்துவம் தேவை. அடிப்படை உலக சேவை தலைமைத்துவம் முதலில் அதனை உருவாக்கியவர்கள் கையில் இருந்தது. அது தற்சமயம் டிரஸ்டிகள் வசம் உள்ளது.",
                        "ஒவ்வொரு சேவை பொறுப்பும் அதற்கென சேவை அதிகாரத்துடன் இணைந்தே போக வேண்டும். அந்த அதிகாரம் என்ன என்பது தெளிவாக வரையறுக்கப்பட வேண்டும்.",
                        "டிரஸ்டிகள் எப்போதும் மிகத் திறமையான கமிட்டிகள்,  கழகச் சேவை இயக்குனர்கள், அதிகாரிகள், ஊழியர்கள், ஆலோசகர்கள் இருக்க வேண்டும். அவர்கள் தகுதி அவர்கள் தேர்ந்தெடுக்கும் வழிமுறைகள், அவர்கள் உரிமைகள், கடமைகள் குறித்து மிகுந்த கவனம் தேவை.",
                        "இந்த மாநாடு AA கோட்பாடுகளின் ஆன்மீக செயலாக்கத்தை கடைபிடிக்கும். ஆபத்தை உருவாக்கும் செல்வம் அல்லது அதிகாரம் ஆகியவற்றில் கவனமாக இருக்கும். அது செயல்பட தேவையான நிதி நிலையும்தான் அதன் பொருளாதார கொள்கை. எந்த ஒரு பொறுப்பில் உள்ளவரும், மற்றவர் மேல் அதிகாரம் செலுத்துதல் கூடாது. முக்கிய முடிவுகள் விவாதம் ஓட்டெடுப்பு அல்லது முடிந்தால் ஒருமித்த கருத்து அடிப்படையில் தீர்வு காணலாம். அதன் எந்த நடவடிக்கையும் தனிநபரை தண்டிக்கும் விதத்திலோ அல்லது மக்கள் மத்தியில் விவாதத்தை ஏற்படுத்தும் வகையிலோ இருக்கக் கூடாது. அரசின் செயல்பாடுகளை AA  செய்யக்கூடாது. அது சேவை செய்ய விரும்பும் சமூகத்திற்கு ஏற்ப அதன் எண்ணமும் செயலும் ஜனநாயக ரீதியில் அமைய வேண்டும்."
                    ]
                },

                stepspage2: {
                    title: "நலமடைதல்",
                    list: [
                        "மதுவை பொறுத்தவரை நாங்கள் சக்தியற்றவர்கள் என ஒப்புக்கொண்டோம் --- வாழ்க்கையை எங்களால் சரிவர நடத்த முடியவில்லை.",
                        "எங்களை விட வலிமை பொருந்திய சக்தி எங்களுக்கு மீண்டும் மனத்தெளிவை திரும்ப அளிக்கக்கூடும் என்ற நம்பிக்கைக்கு வந்தோம்.",
                        "நாங்கள் புரிந்து கொண்ட இறைவனின் பொறுப்பில் எங்கள் சித்தத்தையும் வாழ்க்கையையும் ஒப்படைக்க முடிவு செய்தோம்.",
                        "அச்சமின்றி எங்களைப்பற்றி  ஆழ்ந்த  தார்மீக குணப்பட்டியல் தயார் செய்தோம்.",
                        "இறைவனிடமும், எங்களிடமும்,  மற்றொருவரிடமும் எங்கள் தவறுகளின் உண்மையான தன்மையை ஒப்புக் கொண்டோம்.",
                        "இறைவன் எங்களின் இந்த எல்லாக் குணக் குறைபாடுகளை அகற்ற முழு மனதோடு தயார் படுத்திக் கொண்டோம்.",
                        "எங்களுடைய குறைபாடுகளை நீக்கும்படி இறைவனை பணிவோடு வேண்டினோம்.",
                        "நாங்கள் யாருக்கெல்லாம் தீமை செய்தோம் என்ற பட்டியல் தயாரித்து அவற்றிற்குப் பரிகாரம் செய்யத் தயாரானோம்.",
                        "எங்களால் பாதிக்கப்பட்டவர்களுக்கோ, மற்றவர்களுக்கோ தீங்கு விளைவிக்காவண்ணம் கூடுமானவரையில் நேரிடையாக பரிகாரம் செய்தோம்.",
                        "தொடர்ந்து சுயபரிசீலனை செய்தோம். தவறு செய்த போதெல்லாம் உடனடியாக ஒப்புக்கொண்டோம்.",
                        " பிரார்த்தனை மற்றும் தியானத்தின் மூலம் நாங்கள் புரிந்து கொண்ட இறைவனிடம் உள்ளார்ந்த தொடர்பை வளர்த்துக் கொள்ள முயற்சித்தோம். எங்களுக்காக அவன் சித்தம் என்னவென்று அறிந்து கொள்ளும் அறிவை, மட்டுமே வேண்டி அதை நிறைவேற்றும் சக்தியை கோரி பிரார்த்தித்தோம்",
                        "இந்த வழிமுறைகளை பின்பற்றியதன் பலனாக ஆன்மீக விழிப்பை பெற்றோம், இந்த வழிமுறைகளை மற்றக் குடிநோயாளிகளுக்கு எடுத்துக் கூற முயற்சி செய்தோம், மேலும், இந்தத் தத்துவங்களை எங்கள் வாழ்க்கையின் எல்லா அம்சங்களிலும் கடைபிடிக்க முயற்சித்தோம்."
                    ]
                },

            },
        },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
});

export default i18n;
